/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  text: 'Get more info, tips & ideas for your travel eCommerce at ITB on 4 to 6 March.',
  btnLabel: 'Save a meeting slot now'
})
